import isServer from './isServer';

let clientIPExperimental = null;

setTimeout(async () => {
  if (isServer()) {
    return;
  }
  try {
    const response = await fetch('/fe-api/client-ip', {
      method: 'GET',
    });

    if (!response.ok) {
      return;
    }

    const data = await response.json();
    clientIPExperimental = data?.ip || null;
  } catch (err) {
    /* ignore */
  }
}, 5000);

const getClientIPExperimental = () => clientIPExperimental;

export default getClientIPExperimental;
